import script from "./Best.vue?vue&type=script&setup=true&lang=js"
export * from "./Best.vue?vue&type=script&setup=true&lang=js"

import "./Best.vue?vue&type=style&index=0&id=70146e50&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70146e50"]])

export default __exports__